module.exports = __webpack_public_path__ + "img/75619.6eed7fec.svg";